import { ArrowDownToLine, Pencil, TrashBin, Xmark } from '@gravity-ui/icons';
import { Button, Icon, Sheet } from '@gravity-ui/uikit';
import { useState } from 'react';
import { SheetMenuDelete } from './sheet-menu-delete';

import styles from './styles.module.scss';

export const BlankBlockSheetMenu = ({
	visible,
	setVisible,
	person,
	handleEditBlank,
	handleDownloadBlank,
	handleDeleteBlank,
}: any) => {
	const [visibleDelete, setVisibleDelete] = useState(false);

	return (
		<Sheet visible={visible} onClose={() => setVisible(false)} title="Меню бланка" className={styles.sheet}>
			<div className={styles.sheet__close}>
				<Button onClick={() => setVisible(false)} view="flat">
					<Icon data={Xmark} size={16} />
				</Button>
			</div>
			<div className={styles.sheet__btns}>
				<Button
					size="xl"
					view="flat"
					onClick={(e) => {
						e.stopPropagation();
						handleEditBlank(person.id);
					}}
				>
					<Icon data={Pencil} size={16} />
					Редактировать
				</Button>
				<Button
					size="xl"
					view="flat"
					onClick={(e) => {
						e.stopPropagation();
						handleDownloadBlank(person.id);
					}}
				>
					<Icon data={ArrowDownToLine} size={16} />
					Скачать
				</Button>
				<Button
					size="xl"
					view="flat"
					onClick={(e) => {
						e.stopPropagation();
						setVisibleDelete(true);
					}}
				>
					<Icon data={TrashBin} size={16} />
					Удалить
				</Button>
				<SheetMenuDelete
					onConfirm={() => handleDeleteBlank(person.id)}
					visibleDelete={visibleDelete}
					setVisibleDelete={setVisibleDelete}
				/>
			</div>
		</Sheet>
	);
};
